import { VueElement } from "vue";
// import {
//   FcHome,
//   FcServices,
//   FcCollaboration,
//   FcContacts,
//   FcTodoList,
//   FcAbout,
//   FcList,
//   FcBusiness,
//   FcBusinessman,
//   FcDepartment,
//   FcIdea,
//   FcLike,
//   FcLikePlaceholder,
//   FcManager,
//   FcMultipleDevices,
//   FcPhone,
//   FcMoneyTransfer
// } from "vue-icons-plus/fc";
import { GoPaperAirplane } from "vue-icons-plus/go";

import {
  HiOutlineHome,
  HiOutlineUserGroup,
  HiOutlineUsers,
  HiOutlineClipboardList,
  HiOutlineDocumentText,
  HiOutlinePhone,
  HiOutlineMail,
  HiOutlineChatAlt2,
  HiOutlineCog,
  HiOutlineInformationCircle,
} from "vue-icons-plus/hi";
const HiIcons = [
  { FcHome: HiOutlineHome },
  { FcServices: HiOutlineUserGroup },
  { FcCollaboration: HiOutlineUsers },
  { FcContacts: HiOutlineClipboardList },
  { FcTodoList: HiOutlineDocumentText },
  { FcAbout: HiOutlineInformationCircle },
  { FcList: HiOutlineChatAlt2 },
  { FcBusiness: HiOutlineCog },
  { FcBusinessman: HiOutlineMail },
  { FcDepartment: HiOutlinePhone },
  { FcMoneyTransfer: GoPaperAirplane },
];

// const FcIcons = [
//   { FcHome },
//   { FcServices },
//   { FcCollaboration },
//   { FcContacts },
//   { FcTodoList },
//   { FcAbout },
//   { FcList },
//   { FcBusiness },
//   { FcBusinessman },
//   { FcDepartment },
//   { FcIdea },
//   { FcLike },
//   { FcLikePlaceholder },
//   { FcManager },
//   { FcMultipleDevices },
//   { FcPhone },
//   { FcMoneyTransfer }
// ];

const Icons = HiIcons.reduce<Record<string, VueElement>>
  ((acc, icon) => {
    const iconName = Object.keys(icon)[0];
    const iconComponent = icon[iconName as never] as VueElement;
    acc[iconName] = iconComponent;
    return acc;
  },
    {} as Record<string, VueElement>);

export { Icons };
